import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import { Repair } from '../models/repair.model';
import { ToastrService } from '../services/toastr-service';
import { ApplicationtTextService } from '../services/application-text.service';
import { RepairLineItemsForm, RepairLineItemsFormBulk } from '../form-model/damage-and-repair.form.model';

export function repairCodePieceLimitValidator(
  repairs: Repair[],
  toastrService: ToastrService,
  appTextSvc: ApplicationtTextService,
): ValidatorFn {
  const shownWarnings = new Set<string>(); // to avoid duplicate warnings

  return (control: AbstractControl) => {
    const damageAndRepairForm = control as FormGroup<RepairLineItemsForm | RepairLineItemsFormBulk>;
    const repairLineItems = damageAndRepairForm.get('repairLineItems');
    if (!repairLineItems || !(repairLineItems as any).controls) return null;

    const controls = (repairLineItems as any).controls;

    // Build lookup for piece limits
    const pieceLimitMap: Record<string, number> = {};
    repairs.forEach((repair) => {
      pieceLimitMap[repair.repairCode] = repair.maxQuantity ?? Number.POSITIVE_INFINITY;
    });

    // Calculate total pieces per repairCode
    const repairCodePieceMap: Record<string, number> = {};
    controls.forEach((ctrl: AbstractControl) => {
      const code = ctrl.get('repairCode')?.value;
      const pieces = Number(ctrl.get('pieces')?.value) || 0;
      if (!code) return;
      if (!repairCodePieceMap[code]) {
        repairCodePieceMap[code] = 0;
      }
      repairCodePieceMap[code] += pieces;
    });

    // Check against thresholds and show warning
    for (const code in repairCodePieceMap) {
      const total = repairCodePieceMap[code];
      const limit = pieceLimitMap[code];

      if (limit !== undefined && total > limit && !shownWarnings.has(code)) {
        const warningMsg = appTextSvc.getPieceLimitExceeded(code);
        toastrService.showToastr(warningMsg, 'warning', { duration: 60000 });
        shownWarnings.add(code); // mark it so it's not shown repeatedly
      }

      // Reset warning state if below threshold again
      if (limit !== undefined && total <= limit && shownWarnings.has(code)) {
        shownWarnings.delete(code);
      }
    }

    return null;
  };
}
